// extracted by mini-css-extract-plugin
export default {"banner":"BottomBanner_banner__oqncM","banner__info":"BottomBanner_banner__info__ilF2s","banner__searchButton":"BottomBanner_banner__searchButton__bQl0x"};